import { initMarketoForm } from "./marketo-form-to-rest-api-v2.js";

initMarketoForm();
